import { createFileRoute } from "@tanstack/react-router";
import { TicketList } from "@/components/support/TicketList";

export const Route = createFileRoute("/_public/help/tickets/")({
	component: TicketsPage,
});

function TicketsPage() {
	return <TicketList />;
}
